export const ageMethod = "age nearest";
export const gateway = "https://qat-one-shopper-api.link-nonprod.wawanesalife.com";
export const assets = "https://qat-assets.link-nonprod.wawanesalife.com/brokers/one";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJvbmUiLCJuYW1lIjoib25lIiwiaWF0IjoxNzgwNTg0NjA4LCJleHAiOjE5MzgzNzI2MDh9.VHGD_9PjjH42OkhNdDS2vlvwspa2SQrlXxrhQZfwzTY";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"qat-one-shopper.link-nonprod.wawanesalife.com": {
		a: {
			accessibilityLink: "https://www.oneinsurance.ca/accessibility/",
			approve_company: "Link Platform",
			approve_user: "link_one",
			brands: [
				"qat-one-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "one",
			broker_formatted_name: "One Insurance",
			email: "life@oneinsurance.ca",
			environment: "qat",
			environment_id: "qat",
			g4: "G-C0WK8RKMH9",
			layout: "modern",
			logoPosition: "menu",
			menuPhone: "button",
			phone: "204-953-2967,1043",
			photos: [
				"photo1.jpg",
				"photo2.jpg",
				"photo3.jpg",
				"photo4.jpg",
			],
			privacyLink: "https://www.oneinsurance.ca/privacy-policy",
			website: "https://www.oneinsurance.ca/",
			scope: "one#branding#qat-one-shopper.link-nonprod.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "qat-one-shopper.link-nonprod.wawanesalife.com",
		},
		b: {
			accessibilityLink: "https://www.oneinsurance.ca/accessibility/",
			approve_company: "Link Platform",
			approve_user: "link_one",
			brands: [
				"qat-one-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "one",
			broker_formatted_name: "One Insurance",
			email: "life@oneinsurance.ca",
			environment: "qat",
			environment_id: "qat",
			g4: "G-C0WK8RKMH9",
			layout: "modern",
			logoPosition: "menu",
			menuPhone: "button",
			phone: "204-953-2967,1043",
			photos: [
				"photo1.jpg",
				"photo2.jpg",
				"photo3.jpg",
				"photo4.jpg",
			],
			privacyLink: "https://www.oneinsurance.ca/privacy-policy",
			website: "https://www.oneinsurance.ca/",
			scope: "one#branding#qat-one-shopper.link-nonprod.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "qat-one-shopper.link-nonprod.wawanesalife.com",
		},
	},
};

//updated on Thu Jun 04 2026 14:50:08 GMT+0000 (Coordinated Universal Time)
